import React from 'react'
import { SVGIcon } from '~/utils/types'


export const User = (props: SVGIcon) => (
  <svg {...props} width="32" height="32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.192 20.352c.639.442 1.164.968 1.752 1.72l.224.293c.142.189 1.116 1.557 1.545 2.128l.074.097-.793.61-.372-.5c-.482-.66-1.148-1.594-1.254-1.736-.624-.833-1.13-1.364-1.745-1.79-2.626-1.817-5.958-2.123-8.738-.82-.658.308-1.647 1.088-2.94 2.332l-.246.238L8 22.21c1.49-1.456 2.633-2.373 3.46-2.761 3.106-1.454 6.816-1.115 9.732.904zM15.725 5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm0 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11z"
      fillRule="evenodd"
    />
  </svg>
)
